// extracted by mini-css-extract-plugin
export default {"root":"_sxtc","overlay":"MsA3i","spinner":"kcg7K"};